<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="22"
        viewBox="0 -2 10 18"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.96941 17.5165C8.85444 17.6351 8.72305 17.6923 8.57524 17.6923C8.42332 17.6923 8.29398 17.6351 8.17902 17.5165L0.170395 9.25489C0.0554291 9.1363 -3.93436e-07 9.00075 -3.86678e-07 8.84615C-3.80012e-07 8.69367 0.0554291 8.55813 0.170395 8.43953L8.17902 0.177897C8.29398 0.0614168 8.42332 -6.89188e-08 8.57524 -6.22782e-08C8.72305 -5.5817e-08 8.85444 0.0614169 8.96941 0.177897L9.82755 1.06315C9.94252 1.18175 10 1.3194 10 1.47189C10 1.62649 9.94252 1.76203 9.82755 1.88063L3.07534 8.84615L9.82755 15.8138C9.94252 15.9324 10 16.0679 10 16.2225C10 16.375 9.94252 16.5106 9.82755 16.6292L8.96941 17.5165Z"
            fill="#046791"
        />
    </svg>
</template>
